import { Container, Heading, Text } from "@chakra-ui/react"

import DeactivateConfirmation from "./DeactivateConfirmation"

const DeactivateAccount = () => {
  return (
    <Container maxW="full">
      <Heading size="sm" py={4}>
        Deactivate Account
      </Heading>
      <Text>
        Temporarily deactivate your account. Your data will be preserved and an
        administrator can reactivate your account if needed.
      </Text>
      <DeactivateConfirmation />
    </Container>
  )
}

export default DeactivateAccount
